import React, { isValidElement, Fragment, cloneElement } from 'react';
import parse from 'html-react-parser';

// html-react-parser returns null react keys, so we add them
const applyKeys = (nodes, key) => {
  if (!key) return nodes;

  // react nodes
  if ( /*#__PURE__*/isValidElement(nodes)) {
    return /*#__PURE__*/cloneElement(nodes, {
      key
    });
  }

  // array of elements, recurse
  if (Array.isArray(nodes)) {
    return nodes.map((node, i) => applyKeys(node, `${key}.${i}`));
  }

  // anything else (text, number, etc)
  return /*#__PURE__*/React.createElement(Fragment, {
    key: key
  }, nodes);
};

/**
 * Parse an HTML string.
 */
export default ((htmlStr = '', key) => {
  if (!(typeof htmlStr === 'string' || htmlStr instanceof String)) {
    return htmlStr;
  }
  const trimmedHtmlStr = htmlStr.replace(/(?:\r|\n|\u00a0)/g, ' ').replace(/\s\s+/g, ' ').trim();
  try {
    return applyKeys(parse(trimmedHtmlStr), key);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    return null;
  }
});